// extracted by extract-css-chunks-webpack-plugin
module.exports = {"cookieNotification":"cookieNotification__cookieNotification--1mvjX","darkSpan":"cookieNotification__darkSpan--2fNLy","acceptBtn":"cookieNotification__acceptBtn--1L12H"};